import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsights: ApplicationInsights | null = null;

export function initTelemetry(): ApplicationInsights | null {
  const connectionString = import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING;
  if (!connectionString) return null;

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      disableAjaxTracking: false,
      autoTrackPageVisitTime: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
    },
  });

  appInsights.loadAppInsights();
  return appInsights;
}

export function getAppInsights(): ApplicationInsights | null {
  return appInsights;
}

export function trackPageView(name: string, uri: string): void {
  appInsights?.trackPageView({ name, uri });
}

export function trackException(error: Error): void {
  appInsights?.trackException({ exception: error });
}

export function trackEvent(name: string, properties?: Record<string, string>): void {
  appInsights?.trackEvent({ name, properties });
}
